module.exports = __webpack_public_path__ + "img/de.a1435756.svg";